import type React from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

type Props = {
	label: string;
	qaSelectorLabel: string;
};

export const Label: React.FC<Props> = ({ qaSelectorLabel, label }) => {
	return (
		<Box>
			<Heading as="h2" sx={{ fontWeight: 'bold', lineHeight: '24px', fontSize: '16px' }} data-qa={qaSelectorLabel}>
				{label}
			</Heading>
		</Box>
	);
};
